export default __webpack_public_path__ + "static/twitterSummaryX-6b6dbb95da40ccbc22686befa38ea56e.jpg";